// icon:file-add | Ant Design Icons https://ant.design/components/icon/ | Ant Design
import * as React from "react";

const defaults = {
    width: '1.5em',
    height: '1.5em'
}

export function IconFileAdd(props)
{
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" />
	</svg>
    );
}

export function IconBxFileBlank(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    height="1em"
	    width="1em"
	    {...props}
	>
	    <path d="M19.937 8.68c-.011-.032-.02-.063-.033-.094a.997.997 0 00-.196-.293l-6-6a.997.997 0 00-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 00-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.99.99 0 00-.05-.258zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 001 1h5l.002 10H6z" />
	</svg>
    );
}

export function IconRayStartArrow(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    height="1.5em"
	    width="1.5em"
	    {...props}
	>
	    <path d="M23 12l-4 4v-3H6.83A2.99 2.99 0 014 15a3 3 0 01-3-3 3 3 0 013-3c1.31 0 2.42.83 2.83 2H19V8l4 4z" />
	</svg>
    );
}

export function IconAdd(props) {
    return (
	<svg
	    viewBox="0 0 512 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path
		fill="none"
		stroke="currentColor"
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeWidth={32}
		d="M256 112v288M400 256H112"
	    />
	</svg>
    );
}

export function IconCheckLg(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M12.736 3.97a.733.733 0 011.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 01-1.065.02L3.217 8.384a.757.757 0 010-1.06.733.733 0 011.047 0l3.052 3.093 5.4-6.425a.247.247 0 01.02-.022z" />
	</svg>
    );
}

export function IconEdit(props) {
    return (
	<svg
	    fill="none"
	    stroke="currentColor"
	    strokeLinecap="round"
	    strokeLinejoin="round"
	    strokeWidth={2}
	    viewBox="0 0 24 24"
	    {...defaults}
	    {...props}
	>
	    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
	    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
	</svg>
    );
}

export function IconDividerVertical(props) {
    return (
	<svg fill="none" viewBox="0 0 15 15" {...defaults} {...props}>
	    <path
		fill="currentColor"
		fillRule="evenodd"
		d="M7.5 2a.5.5 0 01.5.5v10a.5.5 0 01-1 0v-10a.5.5 0 01.5-.5z"
		clipRule="evenodd"
	    />
	</svg>
    );
}

export function IconDeleteOutline(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M6 19a2 2 0 002 2h8a2 2 0 002-2V7H6v12M8 9h8v10H8V9m7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
	</svg>
    );
}

export function IconClose(props) {
    return (
	<svg
	    viewBox="0 0 512 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
	</svg>
    );
}

export function IconAddressCard(props) {
    return (
	<svg
	    viewBox="0 0 576 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M208 256c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64c0 35.3 28.7 64 64 64zm256-24h-96c-13.25 0-24 10.75-24 24s10.75 24 24 24h96c13.25 0 24-10.75 24-24s-10.7-24-24-24zm-224 56h-64c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.836 0 16-7.164 16-16 0-44.2-35.8-80-80-80zm224-136h-96c-13.25 0-24 10.75-24 24s10.75 24 24 24h96c13.25 0 24-10.75 24-24s-10.7-24-24-24zm48-120H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm16 384c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V96c0-8.822 7.178-16 16-16h448c8.822 0 16 7.178 16 16v320z" />
	</svg>
    );
}

export function IconTwitter(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0016 3.542a6.658 6.658 0 01-1.889.518 3.301 3.301 0 001.447-1.817 6.533 6.533 0 01-2.087.793A3.286 3.286 0 007.875 6.03a9.325 9.325 0 01-6.767-3.429 3.289 3.289 0 001.018 4.382A3.323 3.323 0 01.64 6.575v.045a3.288 3.288 0 002.632 3.218 3.203 3.203 0 01-.865.115 3.23 3.23 0 01-.614-.057 3.283 3.283 0 003.067 2.277A6.588 6.588 0 01.78 13.58a6.32 6.32 0 01-.78-.045A9.344 9.344 0 005.026 15z" />
	</svg>
    );
}

export function IconSparkles(props) {
    return (
	<svg
	    viewBox="0 0 512 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M208 512a24.84 24.84 0 01-23.34-16l-39.84-103.6a16.06 16.06 0 00-9.19-9.19L32 343.34a25 25 0 010-46.68l103.6-39.84a16.06 16.06 0 009.19-9.19L184.66 144a25 25 0 0146.68 0l39.84 103.6a16.06 16.06 0 009.19 9.19l103 39.63a25.49 25.49 0 0116.63 24.1 24.82 24.82 0 01-16 22.82l-103.6 39.84a16.06 16.06 0 00-9.19 9.19L231.34 496A24.84 24.84 0 01208 512zm66.85-254.84zM88 176a14.67 14.67 0 01-13.69-9.4l-16.86-43.84a7.28 7.28 0 00-4.21-4.21L9.4 101.69a14.67 14.67 0 010-27.38l43.84-16.86a7.31 7.31 0 004.21-4.21L74.16 9.79A15 15 0 0186.23.11a14.67 14.67 0 0115.46 9.29l16.86 43.84a7.31 7.31 0 004.21 4.21l43.84 16.86a14.67 14.67 0 010 27.38l-43.84 16.86a7.28 7.28 0 00-4.21 4.21l-16.86 43.84A14.67 14.67 0 0188 176zM400 256a16 16 0 01-14.93-10.26l-22.84-59.37a8 8 0 00-4.6-4.6l-59.37-22.84a16 16 0 010-29.86l59.37-22.84a8 8 0 004.6-4.6l22.67-58.95a16.45 16.45 0 0113.17-10.57 16 16 0 0116.86 10.15l22.84 59.37a8 8 0 004.6 4.6l59.37 22.84a16 16 0 010 29.86l-59.37 22.84a8 8 0 00-4.6 4.6l-22.84 59.37A16 16 0 01400 256z" />
	</svg>
    );
}

export function IconWandMagicSparkles(props) {
    return (
	<svg
	    viewBox="0 0 576 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1 14.1 37.7c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2l-37.7-14.1L263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5l-14.1 37.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0l381.3-381.4c18.7-18.7 18.7-49.1 0-67.9l-34.6-34.5c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z" />
	</svg>
    );
}

export function IconChatQuote(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M2.678 11.894a1 1 0 01.287.801 10.97 10.97 0 01-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 01.71-.074A8.06 8.06 0 008 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 01-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 00.244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 01-2.347-.306c-.52.263-1.639.742-3.468 1.105z" />
	    <path d="M7.066 6.76A1.665 1.665 0 004 7.668a1.667 1.667 0 002.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 00.6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 008 7.668a1.667 1.667 0 002.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 00.6.58c1.486-1.54 1.293-3.214.682-4.112z" />
	</svg>
    );
}

export function IconBxText(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z" />
	</svg>
    );
}

export function IconUserAdd(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" />
	</svg>
    );
}

export function IconUserDelete(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" />
	</svg>
    );
}

export function IconArrowsMove(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path
		fillRule="evenodd"
		d="M7.646.146a.5.5 0 01.708 0l2 2a.5.5 0 01-.708.708L8.5 1.707V5.5a.5.5 0 01-1 0V1.707L6.354 2.854a.5.5 0 11-.708-.708l2-2zM8 10a.5.5 0 01.5.5v3.793l1.146-1.147a.5.5 0 01.708.708l-2 2a.5.5 0 01-.708 0l-2-2a.5.5 0 01.708-.708L7.5 14.293V10.5A.5.5 0 018 10zM.146 8.354a.5.5 0 010-.708l2-2a.5.5 0 11.708.708L1.707 7.5H5.5a.5.5 0 010 1H1.707l1.147 1.146a.5.5 0 01-.708.708l-2-2zM10 8a.5.5 0 01.5-.5h3.793l-1.147-1.146a.5.5 0 01.708-.708l2 2a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708L14.293 8.5H10.5A.5.5 0 0110 8z"
	    />
	</svg>
    );
}

export function IconBxsBusiness(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M21 7h-6a1 1 0 00-1 1v3h-2V4a1 1 0 00-1-1H3a1 1 0 00-1 1v16a1 1 0 001 1h18a1 1 0 001-1V8a1 1 0 00-1-1zM8 6h2v2H8V6zM6 16H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V6h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm9 4h-2v-2h2v2zm0-4h-2v-2h2v2z" />
	</svg>
    );
}

export function IconBusiness(props) {
    return (
	<svg
	    viewBox="0 0 512 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M432 176H320V64a48 48 0 00-48-48H80a48 48 0 00-48 48v416a16 16 0 0016 16h104a8 8 0 008-8v-71.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01192 416v72a8 8 0 008 8h264a16 16 0 0016-16V224a48 48 0 00-48-48zM98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM444 464H320V208h112a16 16 0 0116 16v236a4 4 0 01-4 4z" />
	    <path d="M400 400a16 16 0 1016 16 16 16 0 00-16-16zM400 320a16 16 0 1016 16 16 16 0 00-16-16zM400 240a16 16 0 1016 16 16 16 0 00-16-16zM336 400a16 16 0 1016 16 16 16 0 00-16-16zM336 320a16 16 0 1016 16 16 16 0 00-16-16zM336 240a16 16 0 1016 16 16 16 0 00-16-16z" />
	</svg>
    );
}

export function IconContacts(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z" />
	</svg>
    );
}

export function IconStarSharp(props) {
    return (
	<svg
	    viewBox="0 0 512 512"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3z" />
	</svg>
    );
}

export function IconDeleteBackLine(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path fill="none" d="M0 0h24v24H0z" />
	    <path d="M6.535 3H21a1 1 0 011 1v16a1 1 0 01-1 1H6.535a1 1 0 01-.832-.445l-5.333-8a1 1 0 010-1.11l5.333-8A1 1 0 016.535 3zm.535 2l-4.666 7 4.666 7H20V5H7.07zM16 11v2H9v-2h7z" />
	</svg>
    );
}

export function IconDeals(props) {
    return (
	<svg viewBox="0 0 512 512"
	     fill="currentColor"
	     {...defaults}
	     {...props}
	>
	    <g>
		<g>
		    <path d="M454.313,249.708L512,206.991L462.136,38.939l-256.667,8.226l-24.727,38.398L92.839,64.42L0,256.087l42.289,36.399
			l-22.328,34.553c-7.052,10.914-9.432,23.92-6.701,36.624c2.73,12.704,10.245,23.583,21.158,30.635
			c7.963,5.146,17.042,7.804,26.304,7.804c2.438,0,4.887-0.193,7.333-0.565c3.097,11.013,10.047,20.988,20.388,27.67
			c8.142,5.262,17.282,7.774,26.323,7.774c2.442,0,4.873-0.206,7.278-0.567c3.198,11.44,10.36,21.2,20.423,27.703
			c8.143,5.262,17.282,7.774,26.323,7.774c15.973,0,31.639-7.845,40.934-22.231l6.634-10.268l38.853,25.758l0.162,0.107
			c7.963,5.146,17.042,7.805,26.304,7.805c3.43,0,6.887-0.365,10.32-1.102c12.704-2.731,23.583-10.246,30.635-21.158
			c4.963-7.681,7.476-16.249,7.745-24.785c2.489-0.146,4.985-0.478,7.47-1.012c12.704-2.731,23.583-10.246,30.635-21.158
			c4.865-7.528,7.504-16.054,7.777-24.787c2.479-0.147,4.963-0.478,7.436-1.01c12.705-2.731,23.584-10.244,30.636-21.158
			c4.968-7.688,7.481-16.267,7.745-24.811c14.973-0.869,29.358-8.609,38.102-22.144c7.052-10.914,9.432-23.92,6.703-36.624
			C464.938,264.277,460.578,256.165,454.313,249.708z M223.819,79.562l213.947-6.856l36.06,121.529l-47.959,35.513L242.472,110.338
			l-52.058,79.011l-0.08,0.123c-4.694,7.26-14.416,9.349-21.676,4.66c-7.26-4.691-9.35-14.415-4.645-21.697L223.819,79.562z
			 M73.986,361.949c-4.694,7.261-14.418,9.35-21.675,4.66c-3.517-2.273-5.939-5.779-6.819-9.873
			c-0.879-4.094-0.113-8.285,2.161-11.802l32.971-51.027c2.997-4.637,8.043-7.164,13.192-7.164c2.913,0,5.86,0.81,8.484,2.505
			c3.517,2.273,5.938,5.778,6.818,9.872s0.113,8.286-2.159,11.803L73.986,361.949z M128.011,396.858
			c-4.694,7.26-14.417,9.348-21.676,4.659c-7.26-4.691-9.35-14.415-4.658-21.675l32.972-51.027
			c2.997-4.637,8.043-7.164,13.192-7.164c2.913,0,5.86,0.81,8.484,2.506c7.26,4.691,9.35,14.415,4.659,21.675L128.011,396.858z
			 M215.006,380.74l-32.972,51.027c-4.691,7.262-14.415,9.349-21.674,4.659c-3.517-2.273-5.939-5.779-6.818-9.873
			c-0.88-4.094-0.114-8.285,2.159-11.803l32.972-51.027c2.273-3.517,5.778-5.938,9.872-6.818c1.107-0.237,2.22-0.355,3.324-0.355
			c2.985,0,5.911,0.857,8.477,2.516C217.607,363.757,219.697,373.48,215.006,380.74z M432.488,292.041
			c-2.273,3.517-5.778,5.938-9.872,6.818c-4.094,0.881-8.286,0.113-11.802-2.159l-10.939-7.068l-0.001-0.001l-51.028-32.972
			l-17.892,27.69l10.94,7.07l40.088,25.904c3.517,2.273,5.938,5.778,6.818,9.872s0.113,8.286-2.159,11.803s-5.779,5.939-9.872,6.819
			c-4.095,0.879-8.285,0.113-11.803-2.159l-51.027-32.972l-17.892,27.69l40.087,25.902c7.26,4.691,9.35,14.414,4.659,21.675
			c-2.273,3.517-5.779,5.939-9.872,6.819c-4.095,0.879-8.285,0.113-11.802-2.159l-43.558-28.145l-17.892,27.69l32.617,21.076
			c7.26,4.693,9.351,14.415,4.659,21.676c-2.273,3.517-5.778,5.939-9.872,6.819c-4.068,0.874-8.232,0.122-11.735-2.117
			l-39.081-25.909l8.443-13.068c14.557-22.529,8.072-52.702-14.457-67.258c-10.349-6.687-22.309-8.922-33.629-7.214
			c-3.094-11.023-10.046-21.008-20.394-27.695c-10.342-6.682-22.292-8.919-33.605-7.217c-3.199-11.436-10.36-21.192-20.42-27.692
			c-18.62-12.034-42.458-9.676-58.391,4.224l-21.076-18.14l70.215-144.958l50.897,12.241l-25.527,39.639
			c-14.557,22.529-8.072,52.701,14.457,67.258c22.506,14.544,52.642,8.083,67.217-14.392l33.979-51.572l175.87,114.508
			c3.516,2.273,5.938,5.778,6.818,9.872C435.528,284.332,434.761,288.523,432.488,292.041z"/>
		</g>
	    </g>
	</svg>
    )
}

export function IconTicketPerforated(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M4 4.85v.9h1v-.9H4zm7 0v.9h1v-.9h-1zm-7 1.8v.9h1v-.9H4zm7 0v.9h1v-.9h-1zm-7 1.8v.9h1v-.9H4zm7 0v.9h1v-.9h-1zm-7 1.8v.9h1v-.9H4zm7 0v.9h1v-.9h-1z" />
	    <path d="M1.5 3A1.5 1.5 0 000 4.5V6a.5.5 0 00.5.5 1.5 1.5 0 110 3 .5.5 0 00-.5.5v1.5A1.5 1.5 0 001.5 13h13a1.5 1.5 0 001.5-1.5V10a.5.5 0 00-.5-.5 1.5 1.5 0 010-3A.5.5 0 0016 6V4.5A1.5 1.5 0 0014.5 3h-13zM1 4.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1.05a2.5 2.5 0 000 4.9v1.05a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1.05a2.5 2.5 0 000-4.9V4.5z" />
	</svg>
    );
}

export function IconBxRefresh(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M10 11H7.101l.001-.009a4.956 4.956 0 01.752-1.787 5.054 5.054 0 012.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 012.018 0 4.978 4.978 0 012.525 1.361l1.416-1.412a7.036 7.036 0 00-2.224-1.501 6.921 6.921 0 00-1.315-.408 7.079 7.079 0 00-2.819 0 6.94 6.94 0 00-1.316.409 7.04 7.04 0 00-3.08 2.534 6.978 6.978 0 00-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 01-2.103 3.138 4.943 4.943 0 01-1.787.752 5.073 5.073 0 01-2.017 0 4.956 4.956 0 01-1.787-.752 5.072 5.072 0 01-.74-.61L7.05 16.95a7.032 7.032 0 002.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 002.818 0 7.031 7.031 0 004.395-2.945 6.974 6.974 0 001.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z" />
	</svg>
    );
}

export function IconCaretUp(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
	</svg>
    );
}

export function IconCaretDown(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" />
	</svg>
    );
}

export function IconBxsMagicWand(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M11 4l-.5-1-.5 1-1 .125.834.708L9.5 6l1-.666 1 .666-.334-1.167.834-.708zm8.334 10.666L18.5 13l-.834 1.666-1.666.209 1.389 1.181L16.834 18l1.666-1.111L20.166 18l-.555-1.944L21 14.875zM6.667 6.333L6 5l-.667 1.333L4 6.5l1.111.944L4.667 9 6 8.111 7.333 9l-.444-1.556L8 6.5zM3.414 17c0 .534.208 1.036.586 1.414L5.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586L20 8.414c.378-.378.586-.88.586-1.414S20.378 5.964 20 5.586L18.414 4c-.756-.756-2.072-.756-2.828 0L4 15.586c-.378.378-.586.88-.586 1.414zM17 5.414L18.586 7 15 10.586 13.414 9 17 5.414z" />
	</svg>
    );
}

// icon:stars | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
export function IconStars(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 001.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 00-1.828 1.829l-.645 1.936a.361.361 0 01-.686 0l-.645-1.937a2.89 2.89 0 00-1.828-1.828l-1.937-.645a.361.361 0 010-.686l1.937-.645a2.89 2.89 0 001.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 01.412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 010 .412l-1.162.387A1.734 1.734 0 004.593 5.69l-.387 1.162a.217.217 0 01-.412 0L3.407 5.69A1.734 1.734 0 002.31 4.593l-1.162-.387a.217.217 0 010-.412l1.162-.387A1.734 1.734 0 003.407 2.31l.387-1.162zM10.863.099a.145.145 0 01.274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 010 .274l-.774.258a1.156 1.156 0 00-.732.732l-.258.774a.145.145 0 01-.274 0l-.258-.774a1.156 1.156 0 00-.732-.732L9.1 2.137a.145.145 0 010-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z" />
	</svg>
    );
}

// icon:wi-stars | Weather Icons https://erikflowers.github.io/weather-icons/ | Eric Flowers
export function IconWiStars(props) {
    return (
	<svg
	    viewBox="0 0 30 30"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M5.37 16.18c.65-.03 1.2-.28 1.65-.75.45-.47.68-1.03.68-1.68 0 .65.22 1.21.67 1.68.45.47 1 .72 1.65.75-.65.03-1.2.28-1.65.75a2.34 2.34 0 00-.67 1.68c0-.65-.22-1.21-.68-1.68-.45-.47-1-.72-1.65-.75zm2.33-7.2c1.26-.06 2.33-.55 3.21-1.47.88-.92 1.32-2.01 1.32-3.28 0 1.27.44 2.36 1.32 3.28s1.95 1.4 3.22 1.47c-.83.04-1.59.27-2.29.71-.69.43-1.24 1.01-1.65 1.73-.4.72-.6 1.49-.6 2.33 0-1.27-.44-2.37-1.32-3.29-.88-.93-1.95-1.42-3.21-1.48zm3.32 10.77c.95-.04 1.76-.41 2.42-1.1.66-.69.99-1.51.99-2.47 0 .96.33 1.78.99 2.47.66.69 1.46 1.06 2.41 1.1-.95.04-1.75.41-2.41 1.1-.66.69-.99 1.51-.99 2.47 0-.96-.33-1.78-.99-2.47a3.503 3.503 0 00-2.42-1.1zm6.81-4.74c.95-.04 1.75-.41 2.41-1.1.66-.69.98-1.51.98-2.48 0 .96.33 1.78.99 2.47s1.47 1.06 2.42 1.1c-.95.04-1.76.41-2.42 1.1-.66.69-.99 1.51-.99 2.47 0-.96-.33-1.78-.98-2.47-.66-.68-1.46-1.05-2.41-1.09z" />
	</svg>
    );
}

// icon:bxs-chevrons-right | Boxicons https://boxicons.com/ | Atisa
export function IconBxsChevronsRight(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M13.061 4.939l-2.122 2.122L15.879 12l-4.94 4.939 2.122 2.122L20.121 12z" />
	    <path d="M6.061 19.061L13.121 12l-7.06-7.061-2.122 2.122L8.879 12l-4.94 4.939z" />
	</svg>
    );
}

// icon:caret-right-fill | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
export function IconCaretRightFill(props) {
    return (
	<svg
	    fill="currentColor"
	    viewBox="0 0 16 16"
	    {...defaults}
	    {...props}
	>
	    <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 011.659-.753l5.48 4.796a1 1 0 010 1.506z" />
	</svg>
    );
}

// icon:airtable | Simple Icons https://simpleicons.org | SimpleIcons.org
export function IconAirtable(props) {
    return (
	<svg viewBox="0 -20.5 256 256"
	     {...defaults}
	     {...props}>
	    <g>
		<path d="M114.25873,2.70101695 L18.8604023,42.1756384 C13.5552723,44.3711638 13.6102328,51.9065311 18.9486282,54.0225085 L114.746142,92.0117514 C123.163769,95.3498757 132.537419,95.3498757 140.9536,92.0117514 L236.75256,54.0225085 C242.08951,51.9065311 242.145916,44.3711638 236.83934,42.1756384 L141.442459,2.70101695 C132.738459,-0.900338983 122.961284,-0.900338983 114.25873,2.70101695" fill="#FFBF00">
		</path>
		<path d="M136.349071,112.756863 L136.349071,207.659101 C136.349071,212.173089 140.900664,215.263892 145.096461,213.600615 L251.844122,172.166219 C254.281184,171.200072 255.879376,168.845451 255.879376,166.224705 L255.879376,71.3224678 C255.879376,66.8084791 251.327783,63.7176768 247.131986,65.3809537 L140.384325,106.815349 C137.94871,107.781496 136.349071,110.136118 136.349071,112.756863" fill="#26B5F8">
		</path>
		<path d="M111.422771,117.65355 L79.742409,132.949912 L76.5257763,134.504714 L9.65047684,166.548104 C5.4112904,168.593211 0.000578531073,165.503855 0.000578531073,160.794612 L0.000578531073,71.7210757 C0.000578531073,70.0173017 0.874160452,68.5463864 2.04568588,67.4384994 C2.53454463,66.9481944 3.08848814,66.5446689 3.66412655,66.2250305 C5.26231864,65.2661153 7.54173107,65.0101153 9.47981017,65.7766689 L110.890522,105.957098 C116.045234,108.002206 116.450206,115.225166 111.422771,117.65355" fill="#ED3049">
		</path>
		<path d="M111.422771,117.65355 L79.742409,132.949912 L2.04568588,67.4384994 C2.53454463,66.9481944 3.08848814,66.5446689 3.66412655,66.2250305 C5.26231864,65.2661153 7.54173107,65.0101153 9.47981017,65.7766689 L110.890522,105.957098 C116.045234,108.002206 116.450206,115.225166 111.422771,117.65355" fill-opacity="0.25" fill="#000000">
		</path>
	    </g>
	</svg>
    );
}

// icon:create-dashboard | Unicons https://iconscout.com/unicons | Iconscout
export function IconCreateDashboard(props) {
    return (
	<svg
	    data-name="Layer 1"
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M10 13H4a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1zm-1 6H5v-4h4zM20 3h-6a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1zm-1 6h-4V5h4zm1 7h-2v-2a1 1 0 00-2 0v2h-2a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 000-2zM10 3H4a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1zM9 9H5V5h4z" />
	</svg>
    );
}

// icon:bx-reset | Boxicons https://boxicons.com/ | Atisa
export function IconBxReset(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z" />
	    <path d="M20.817 11.186a8.94 8.94 0 00-1.355-3.219 9.053 9.053 0 00-2.43-2.43 8.95 8.95 0 00-3.219-1.355 9.028 9.028 0 00-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 012.502 1.053 7.005 7.005 0 011.892 1.892A6.967 6.967 0 0119 13a7.032 7.032 0 01-.55 2.725 7.11 7.11 0 01-.644 1.188 7.2 7.2 0 01-.858 1.039 7.028 7.028 0 01-3.536 1.907 7.13 7.13 0 01-2.822 0 6.961 6.961 0 01-2.503-1.054 7.002 7.002 0 01-1.89-1.89A6.996 6.996 0 015 13H3a9.02 9.02 0 001.539 5.034 9.096 9.096 0 002.428 2.428A8.95 8.95 0 0012 22a9.09 9.09 0 001.814-.183 9.014 9.014 0 003.218-1.355 8.886 8.886 0 001.331-1.099 9.228 9.228 0 001.1-1.332A8.952 8.952 0 0021 13a9.09 9.09 0 00-.183-1.814z" />
	</svg>
    );
}

// icon:bx-slideshow | Boxicons https://boxicons.com/ | Atisa
export function IconBxSlideshow(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 15V5h16l.001 10H4z" />
	    <path d="M10 13l5-3-5-3z" />
	</svg>
    );
}

// icon:home | Ant Design Icons https://ant.design/components/icon/ | Ant Design
export function IconHome(props) {
    return (
	<svg
	    viewBox="0 0 1024 1024"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" />
	</svg>
    );
}

// icon:open-in-new | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
export function IconOpenInNew(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7z" />
	</svg>
    );
}

// icon:bx-badge-check | Boxicons https://boxicons.com/ | Atisa
export function IconBxBadgeCheck(props) {
    return (
	<svg
	    viewBox="0 0 24 24"
	    fill="currentColor"
	    {...defaults}
	    {...props}
	>
	    <path d="M4.035 15.479A3.976 3.976 0 004 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403l1.102-.293-.434-1.053A1.932 1.932 0 016 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 013.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 010 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 01-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 018 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 010-3.848z" />
	    <path d="M15.742 10.71l-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z" />
	</svg>
    );
}
